import React, { useEffect, useState } from "react";
import { useNetworkStatus } from "../../context/NetworkStatusContext";

export default function GlobalNetworkBanner() {
  const { isOffline, wasOffline, clearWasOffline } = useNetworkStatus();
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (!isOffline && wasOffline) {
      setShowReconnected(true);

      const timer = setTimeout(() => {
        setShowReconnected(false);
        clearWasOffline();
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOffline, wasOffline, clearWasOffline]);

  if (isOffline) {
    return (
      <div className="sticky top-0 z-[100] border-b border-amber-200 bg-gradient-to-r from-amber-50 to-orange-50 px-4 py-3 text-sm text-amber-900 shadow-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
          <div className="font-medium">
            Network disconnected. Check your internet connection.
          </div>
        </div>
      </div>
    );
  }

  if (showReconnected) {
    return (
      <div className="sticky top-0 z-[100] border-b border-emerald-200 bg-gradient-to-r from-emerald-50 to-teal-50 px-4 py-3 text-sm text-emerald-900 shadow-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-3">
          <div className="font-medium">Connection restored.</div>
        </div>
      </div>
    );
  }

  return null;
}